import type { ElementType, HTMLAttributes } from "react"

import { tv, type VariantProps } from "@/lib/utils/tv"

const text = tv({
  variants: {
    variant: {
      lede: "text-lede",
      bodyLg: "text-body-lg",
      body: "text-body",
      bodySm: "text-body-sm",
      label: "text-label",
      captionLg: "text-caption-lg",
      caption: "text-caption",
      micro: "text-micro",
      eyebrow: "font-display text-overline uppercase",
      panelLabel: "text-overline font-semibold",
      figure: "text-flow-display-xs-bold",
    },
    family: {
      text: "font-text",
      display: "font-display",
      mono: "font-mono",
    },
    tone: {
      default: "text-fg",
      strong: "text-fg-strong",
      secondary: "text-fg-secondary",
      title: "text-fg-title",
      muted: "text-fg-muted",
      subtle: "text-fg-subtle",
      faint: "text-fg-faint",
      inverted: "text-fg-inverted",
      invertedMuted: "text-fg-inverted-muted",
      brand: "text-fg-brand",
      danger: "text-fg-danger",
      sale: "text-fg-sale",
      success: "text-fg-success",
      warning: "text-fg-warning",
      promise: "text-fg-promise",
      receipt: "text-fg-receipt",
      inherit: "",
    },
    numeric: { true: "tabular-nums" },
    balance: { true: "text-balance" },
    truncate: { true: "truncate" },
  },
  defaultVariants: { variant: "body", tone: "default" },
})

export interface TextProps extends HTMLAttributes<HTMLElement>, VariantProps<typeof text> {
  as?: ElementType
}

export const Text = ({ as: Component = "p", variant, family, tone, numeric, balance, truncate, className, ...rest }: TextProps) => (
  <Component className={text({ variant, family, tone, numeric, balance, truncate, className })} {...rest} />
)
